import type { components } from "#/schema";

type SchoolSelectModel = components["schemas"]["SchoolSelectModel"];

/**
 * Pure helper (safe to import from client or server): whether the given school slug is one of
 * the user's schools. Portal reads `scholen` from middleware context; in the port the caller
 * already has `scholen` from the user metadata, so it is passed in explicitly.
 */
export function doesSchoolSlugExistInMySchools(
  scholen: SchoolSelectModel[],
  slug: string,
): boolean {
  return Boolean(scholen?.some((school) => school.slug === slug));
}
